import React from 'react';
import { TableHead, TableRow, TableCell, Checkbox, IconButton } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterAltIcon from '@mui/icons-material/FilterAlt';             // מלא
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined'; // חלול


/**
 * קומפוננטה המייצגת את החלק העליון (Header) של הטבלה:
 * - צ'קבוקס ראשי לבחירה כללית
 * - כותרות עמודות (headerName)
 * - אייקון סינון לעמודה
 * - אפשרות לגרירה להרחבת עמודה
 */
const GenericTableHeader = ({
  columns,
  columnWidths,
  selectedRows,
  rows,
  onSelectAllToggle, // פונקציה שתופעל בלחיצה על הצ'קבוקס הראשי
  handleMouseDown, // פונקציית גרירה לשינוי רוחב
  handleFilterClick, // פונקציה לפתיחת תפריט הסינון בעמודה
  filters // פילטר סינון עמודה
}) => {
  return (
    <TableHead sx={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 100 }}>
      <TableRow>
        {/* צ'קבוקס כללי לבחירה מרובה */}
        <TableCell
          style={{
            minWidth: '5px',
            maxWidth: '5px',
            textAlign: 'center',
            paddingLeft: '35px'
          }}>
          <Checkbox size="small" checked={selectedRows.length === rows.length && rows.length > 0} indeterminate={selectedRows.length > 0 && selectedRows.length < rows.length} onChange={onSelectAllToggle} />
        </TableCell>

        {/* עמודות */}

        {columns.map((column, index) => {
          const isFiltered = !!filters[column.field]; // true אם יש פילטר עבור column.field
          return (
            <TableCell
              key={index}
              style={{
                minWidth: Math.max(columnWidths[index], 120),
                position: 'relative'
              }}>
              {/* טקסט כותרת עם ellipsis */}
              <div
                style={{
                  maxWidth: columnWidths[index] - 10,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  paddingLeft: '30px'
                }}>
                {column.headerName}
              </div>

              {/* אייקון סינון */}
              <IconButton
                size="small"
                onClick={(e) => handleFilterClick(e, column)}
                style={{
                  position: 'absolute',
                  left: '8px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  zIndex: 2
                }}>
                {isFiltered ? 
                  <FilterAltIcon fontSize="small" color="primary" /> : 
                  <FilterAltOutlinedIcon fontSize="small" color="inherit" />
                }
              </IconButton>

              {/* אזור לגרירה (לשינוי רוחב העמודה) */}
              <div
                style={{
                  position: 'absolute',
                  left: '-7px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  height: '60%',
                  width: '24px',
                  cursor: 'col-resize',
                  zIndex: 1
                }}
                onMouseDown={(e) => handleMouseDown(index, e)}>
                <div
                  style={{
                    width: '5px',
                    height: '100%',
                    margin: '0 auto',
                    backgroundColor: '#ccc'
                  }}
                />
              </div>
            </TableCell>
          );
        })}

        {/* תאי ריקים לאיקוני עריכה/מחיקה */}
        <TableCell style={{ minWidth: '50px', maxWidth: '50px' }} />
        <TableCell style={{ minWidth: '50px', maxWidth: '50px' }} />

        {/* Spacer */}
        <TableCell style={{ width: '100%' }} />
      </TableRow>
    </TableHead>
  );
};

export default GenericTableHeader;
